import { transferHandlers, expose, proxy, releaseProxy } from 'comlink/dist/esm/comlink.mjs'
import nodeEndpoint from 'comlink/dist/esm/node-adapter.mjs'
import currency from 'currency.js'
import moment from 'moment'
import lodash from 'lodash'
import jmespath from 'jmespath'
import soql from '../utils/soql-utils'
import xml from 'fast-xml-parser'
import { fetch } from 'cross-fetch'
import walkObj from '../utils/walkObj'
import Handlebars from 'handlebars'

class Result {
  constructor(result) {
    this.data = result
  }
}

transferHandlers.set('Result', {
  canHandle: obj => obj instanceof Result,
  serialize: obj => {
    walkObj(obj.data, (path, value) => {
      if(typeof value === 'function') {
        lodash.set(obj.data, path, transferHandlers.get('proxy').serialize(value))
      }

    }, undefined, true)
    return [obj.data, []]
  },
  deserialize: obj => obj
})
class JSRunner {
  constructor(keys, ...values) {
    const context = lodash.zipObject(keys, values)
    this.scope = {
      jmespath,
      currency,
      _: lodash,
      moment,
      transform: soql.query,
      xml,
      self: {},
      globalThis: {},
      fetch,
      Handlebars,
      ...context
    }
  }
    
  exec = async (code, ...params) => {
    let scoped = new Function(...Object.keys(this.scope), `'use strict';return (${code});`)
    let fn = scoped(...Object.values(this.scope))
    const result = await fn(...params)
    params.forEach(p => p?.[releaseProxy]?.())
    //return new Result(result)
    if(typeof result === 'function') {
      return proxy(result)
    }
    return result
  }
  
  die() {
    if(typeof process !== 'undefined') process?.exit?.(0)
  }
}

if(typeof window === 'undefined' && typeof self === 'undefined') {
  import('worker_threads').then(m => {
    expose(JSRunner, nodeEndpoint(m.parentPort))
  })
} else {
  expose(JSRunner, self)
}
